// /**
//  * Message - list
//  */

// React
import React, { useContext, useState } from "react";

// Context
import AuthContext from "../../authContext";

// UI
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
} from "@material-ui/core";

// Icon
import Icon from "@mdi/react";
import {
  mdiChevronDown,
  mdiChevronUp,
  mdiCheckAll,
  mdiEyeOffOutline,
  mdiEyeOutline,
  mdiCheck,
  mdiDelete,
  mdiClose,
} from "@mdi/js";

// Components
import { checkMatchMedia } from "../../utils/helpers";
import jMoment from "moment-jalaali";

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      textAlign: "left",
      padding: "10px 0",
      backgroundColor: "#d3d6e8 !important",
      color: "#212121",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "@media (max-width: 768px)": {
        fontSize: 10,
      },
    },
    body: {
      textAlign: "left",
      padding: "10px 10px",
      borderRadius: "0",
      fontSize: 14,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    paper: {
      width: "100%",
    },
    table: {
      // minWidth: 750,
      border: "1px solid #2F485833",
      borderRadius: "4px",
      boxShadow: "8px 8px 21px -5px rgba(0,0,0,0.27)",
    },
    hover: {
      "&:hover": {
        backgroundColor: "#F8F9FA !important",
      },
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: "0 10px",
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 750,
      borderRadius: "0",
      boxShadow: "-4px 4px 12px 5px rgba(0,0,0,0.06)",
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        width: "1px",
        height: "36px",
        top: "4px",
        left: "-9px",
        backgroundColor: "#EDF1F4",
      },
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    badge: {
      backgroundColor: "#fff5e9",
      borderRadius: "30px",
      color: "#ec6839",
      fontSize: "12px",
      border: "1px solid #ec6839",
      padding: "6px 12px",
    },
    disableBg: {
      backgroundColor: "#FFCCCB !important",
      borderRadius: "5px",
      padding: "5px",
      "&:hover": {
        backgroundColor: "#FFCCCB !important",
      },
    },
    enableBg: {
      backgroundColor: "rgba(50, 153, 38, 0.17)",
      borderRadius: "5px",
      padding: "5px",
      cursor: "default",
      "&:hover": {
        backgroundColor: "rgba(50, 153, 38, 0.17)",
      },
    },
    disable: {
      backgroundColor: "#FFFFFF !important",
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: any,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function EnhancedTableHead(props: any) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler =
    (property: any) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  const headCells = [
    {
      id: "title",
      label: "عنوان",
    },
    {
      id: "ronadUserName",
      label: "گیرنده",
    },
    {
      id: "created",
      label: "ساعت ایجاد",
    },
    {
      id: "seenTime",
      label: "ساعت مشاهده",
    },
  ];

  return (
    <TableHead>
      <TableRow style={{ borderRadius: "0" }}>
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              classes={{
                // Override with the active class if this is the selected column or inactive otherwise
                icon:
                  orderBy === headCell.id
                    ? classes.activeSortIcon
                    : classes.inactiveSortIcon,
              }}
              IconComponent={() => (
                <Icon
                  path={
                    orderBy === headCell.id && order === "desc"
                      ? mdiChevronDown
                      : mdiChevronUp
                  }
                  size={0.7}
                  className={
                    orderBy === headCell.id
                      ? classes.activeSortIcon
                      : classes.inactiveSortIcon
                  }
                />
              )}
            >
              <span className={classes.columnText}>{headCell.label}</span>
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: any) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = React.useState("desc");
  const [showMessage, setShowMessage] = React.useState({});
  const [orderBy, setOrderBy] = React.useState("id");
  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const fixDate = (date) => {
    const dateArray = date.split("T");
    const time = dateArray[1].split('Z');

    return { date: dateArray[0], time: time[0] };
  };
  return (
    <div className={classes.root}>
      <div>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={checkMatchMedia("(max-width: 1024px)") ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.data.length}
            />

            <TableBody>
              {stableSort(props.data, getComparator(order, orderBy))
                .slice()
                .map((row: any, index: number) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <>
                      <TableRow
                        className={classes.hover}
                        key={index}
                        role="checkbox"
                        tabIndex={-1}
                      >
                        <StyledTableCell
                          id={labelId}
                          scope="row"
                          align="center"
                        >
                          {row.title}
                          &nbsp;
                          <IconButton
                            onClick={() => {
                              const messageStatus = { ...showMessage };
                              if (messageStatus[row.id]) {
                                messageStatus[row.id] = !messageStatus[row.id];
                              } else {
                                messageStatus[row.id] = true;
                              }
                              setShowMessage(messageStatus);
                            }}
                          >
                            <Icon
                              path={
                                showMessage[row.id]
                                  ? mdiChevronUp
                                  : mdiChevronDown
                              }
                              size={1}
                            />
                          </IconButton>
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.seenDTO.ronadUserName}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <span>
                            {`${jMoment(fixDate(row.created).time, "HH:mm:ss")
                              .add(3, "hours")
                              .add(30, "minutes")
                              .locale("fa")
                              .format("HH:mm:ss")}
                            `}
                          </span>
                          &nbsp; &nbsp;- &nbsp; &nbsp;
                          <span>
                            {jMoment(fixDate(row.created).date, "YYYY/M/D")
                              .locale("fa")
                              .format("jYYYY/jMM/jDD")}
                          </span>
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          {row.seenDTO.seenTime && (
                            <>
                              <span>
                                {`${jMoment(
                                  fixDate(row.seenDTO.seenTime).time,
                                  "HH:mm:ss"
                                )
                                  .add(3, "hours")
                                  .add(30, "minutes")
                                  .locale("fa")
                                  .format("HH:mm:ss")}
                              `}
                              </span>
                              &nbsp; &nbsp;- &nbsp; &nbsp;
                              <span>
                                {jMoment(
                                  fixDate(row.seenDTO.seenTime).date,
                                  "YYYY/M/D"
                                )
                                  .locale("fa")
                                  .format("jYYYY/jMM/jDD")}
                              </span>
                            </>
                          )}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{
                            textAlign: "left",
                          }}
                        >
                          <IconButton onClick={() => props.openConfirm(row.id)} >
                            <Icon path={mdiClose} size={1}/>
                          </IconButton>
                          <Icon
                            path={
                              !row.deleted ? mdiEyeOutline : mdiEyeOffOutline
                            }
                            size={1}
                          />

                          <Icon
                            path={row.seenDTO.seen ? mdiCheckAll : mdiCheck}
                            size={1}
                            color="#4C7956"
                          />
                        </StyledTableCell>
                      </TableRow>
                      {showMessage[row.id] && (
                        <TableRow>
                          <TableCell
                            style={{
                              backgroundColor: "#ECECEC",
                              padding: "12px",
                              textJustify: "inter-word",
                              textAlign: "justify",
                            }}
                            colSpan={5}
                          >
                            {`${row.message}`}
                          </TableCell>
                        </TableRow>
                      )}
                    </>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}
